import { useState, useEffect } from 'react'
import { Auth } from 'aws-amplify'
import axios from 'axios'
const MscItemList = ({mscItem, setMscItemData, setErrorMsg}) => {
  const [editCodeValue, setEditCodeValue] = useState(false)
  const [saving, setSaving] = useState(false)
  const [newMscCode, setNewMscCode] = useState(mscItem.msc_code)
  const [newMscPlantCode, setNewMscPlantCode] = useState(mscItem.plant_code)
  const [buttonLabel, setButtonLabel] = useState('Edit')

  useEffect(() => {
    setButtonLabel(editCodeValue ? 'Cancel' : 'Edit')
  }, [editCodeValue])

  const onEditClick = () => {
    setEditCodeValue(!editCodeValue)
    if (!editCodeValue) {
        setEditCodeValue(mscItem.msc_id)
    }
  }
  const saveMscItem = async (e) => {
    e.preventDefault()

    setSaving(true)
    setErrorMsg(null)
    let session = await Auth.currentSession()
    let jwt = session.getIdToken().getJwtToken()

    const updateType = 'update'
    axios
    .put(`${process.env.REACT_APP_API_URL}/msccode`, {mscId: mscItem.msc_id, mscCode: newMscCode, plantCode: newMscPlantCode, updateType}, 
    {headers: {Authorization: jwt}}
    )
    .then(response => {
        setSaving(false)
        if (response.data.error) {
            setErrorMsg(response.data.error)
        } 
        onEditClick()
        setMscItemData(response.data.rows)
    }) 
    .catch(error => {
        console.log('The error is: ', error)
        setErrorMsg('Problem saving data: ', error)
        setSaving(false)
    })                 
}

  return (
    <tr key={mscItem.msc_id}>
        <td>
          {!editCodeValue && mscItem.msc_code}
          {editCodeValue &&
            <input 
            type="text"
            min="0"
            className="text-input__customer-add"
            name="mscCode"
            value={newMscCode || ''}
            disabled={saving}
            onChange={e => setNewMscCode(e.target.value) } />
          }
        </td>
        <td>
          {!editCodeValue && mscItem.plant_code}
          {editCodeValue &&
            <input 
            type="text"
            min="0"
            className="text-input__customer-add"
            name="plantCode"
            value={newMscPlantCode || ''}
            disabled={saving}
            onChange={e => setNewMscPlantCode(e.target.value) } />
          }
        </td>        
        <td>
          <button className="table-button__small" onClick={onEditClick} disabled={saving} >{buttonLabel}</button>
        </td>
        <td>
          <button className="table-button__small" onClick={saveMscItem} 
              disabled={saving || !editCodeValue || !newMscCode || !newMscPlantCode} >Save
          </button>
        </td>
    </tr>
  )
}

export default MscItemList